export default __webpack_public_path__ + "static/media/cat-5-2.64efa808.png";